exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".m-round[data-v-2a8edac8]{border-radius:50%}.box[data-v-2a8edac8]{width:150px;height:150px;position:relative}.image-circle[data-v-2a8edac8]{width:150px!important;border-radius:50%;position:absolute}.image-circle[data-v-2a8edac8],.image-rec[data-v-2a8edac8]{height:150px!important;background:50% no-repeat;background-size:cover;-webkit-box-shadow:0 0 5px 1px rgba(0,0,0,.2);box-shadow:0 0 5px 1px rgba(0,0,0,.2)}.image-rec[data-v-2a8edac8]{width:100%!important;border-radius:10px}.box2[data-v-2a8edac8]{z-index:10}.container[data-v-2a8edac8]{padding:0;margin-top:10px}", ""]);

// exports
